/**
 * Usage:
 *
 *     connect() {
 *       useEvent(this, 'click', this.myFunction, { element: window })
 *     }
 *
 * The `element:` defaults to the controller element. All other options are
 * passed to `addEventListener` for use with e.g. `capture` or `bubbles`.
 */
export function useEvent(controller, event, fn, options = {}) {
  if (!controller || !event || typeof fn !== 'function') return null;

  const { element, ...listenerOptions } = options || {};
  /** @type {HTMLElement | Window | Document | null} */
  const target = element || controller.element;
  if (!target) return null;

  const onEvent = fn.bind(controller);
  target.addEventListener(event, onEvent, listenerOptions);

  const controllerDisconnect =
    typeof controller.disconnect === 'function'
      ? controller.disconnect.bind(controller)
      : null;

  Object.assign(controller, {
    disconnect() {
      target.removeEventListener(event, onEvent, listenerOptions);
      controllerDisconnect?.();
    },
  });
}
